/**
 * klubb-plp-loadmore — «Last flere» appends the next page of products to the
 * grid instead of navigating. The button is a real link to the next page, so
 * it still works without JS and falls back to navigation if the fetch fails.
 * ESM module; exports pure helpers for unit tests.
 */

export function countLabel(template, shown) {
  return String(template || '').replace('__SHOWN__', String(shown));
}

/**
 * Moves the product cards from a fetched page into the current grid and
 * swaps in that page's pager state. Returns the number of cards added.
 */
export function appendPage(root, nextDoc) {
  const grid = root.querySelector('[data-klubb-plp-grid]');
  const nextGrid = nextDoc.querySelector('[data-klubb-plp-grid]');
  if (!grid || !nextGrid) return 0;

  const cards = Array.from(nextGrid.children);
  cards.forEach((card) => grid.appendChild(root.ownerDocument.importNode(card, true)));

  const pager = root.querySelector('[data-klubb-loadmore]');
  if (!pager) return cards.length;

  const shown = grid.children.length;
  const total = Number(pager.getAttribute('data-total')) || shown;
  const label = pager.querySelector('[data-klubb-loadmore-count]');
  if (label) label.textContent = countLabel(pager.getAttribute('data-count-template'), shown);
  const fill = pager.querySelector('[data-klubb-loadmore-fill]');
  if (fill) fill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';

  const btn = pager.querySelector('[data-klubb-loadmore-btn]');
  const nextBtn = nextDoc.querySelector('[data-klubb-loadmore-btn]');
  if (btn) {
    if (nextBtn && nextBtn.getAttribute('href')) {
      btn.setAttribute('href', nextBtn.getAttribute('href'));
    } else {
      btn.remove();
    }
  }
  return cards.length;
}

(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function wire() {
    document.addEventListener('click', (event) => {
      const btn = event.target.closest && event.target.closest('[data-klubb-loadmore-btn]');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
      const href = btn.getAttribute('href');
      const root = btn.closest('[data-klubb-plp-main]');
      if (!href || !root || typeof fetch !== 'function') return;

      event.preventDefault();
      btn.setAttribute('aria-busy', 'true');
      fetch(href, { credentials: 'same-origin' })
        .then((res) => {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then((html) => {
          const nextDoc = new DOMParser().parseFromString(html, 'text/html');
          if (appendPage(root, nextDoc) === 0) throw new Error('no products in response');
          btn.removeAttribute('aria-busy');
        })
        .catch(() => {
          window.location.href = href;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
